var _a;
import { handleActions } from 'redux-actions';
import { increment, decrement } from 'shared/redux/helpers/counter';
import { NAMES as SERVER_CHANNEL_VIDEOS_LIST } from 'shared/redux/server/actions/channel/videos/list-public';
export default handleActions((_a = {},
    _a[SERVER_CHANNEL_VIDEOS_LIST.START] = increment,
    _a[SERVER_CHANNEL_VIDEOS_LIST.SUCCESS] = decrement,
    _a[SERVER_CHANNEL_VIDEOS_LIST.FAIL] = decrement,
    _a), 0);
